import { useQuery } from "@tanstack/react-query";
import { leagueRepository } from "@/config/dataSource";
import { leaguesQueryKeys } from "@/modules/leagues/hooks/useLeagues";

export function useLeague(leagueId: string | undefined) {
  return useQuery({
    queryKey: leaguesQueryKeys.detail(leagueId ?? "unknown"),
    queryFn: () => leagueRepository.getLeagueById(leagueId as string),
    enabled: Boolean(leagueId),
  });
}
